import { render, staticRenderFns } from "./Astronaut.vue?vue&type=template&id=56e88632&scoped=true&"
import script from "./Astronaut.vue?vue&type=script&lang=js&"
export * from "./Astronaut.vue?vue&type=script&lang=js&"
import style0 from "./Astronaut.vue?vue&type=style&index=0&id=56e88632&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e88632",
  null
  
)

export default component.exports